import { useMediaQuery } from "@mui/material";

export const usePlatform = () => {
  const isMobile = useMediaQuery("(max-width: 721px)");
  return isMobile ? "MOBILE" : "DESKTOP";
};
